import { List, styled } from '@mui/material';

const ChatsListMui = styled(List)`
  padding: 0;
`;

export { ChatsListMui };
